<template>
  <div class="popular-container">

    <div class="three-cards-group">
      <b-card-group deck class="deck-cards row">
        <b-card
          v-on:click="toggleCard(product)"
          v-for="(product, index) in activeCards"
          :key="product.id"
          :title="product.productTitle"
          :sub-title="product.description"
          :img-src="product.cardImage"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow add-border-radius col-md-4"
          id="productCard"
          style="min-width: 14.1rem; max-width: 18rem; padding: 0;"

        >
          <b-card-text >
          <span class="original-price text-secondary">
            {{ showPrice(index) }}</span> {{showPriceByPlan(index)}}
          </b-card-text>

          <b-card-text class="text-secondary" v-b-tooltip.hover.bottom.v-dark="showPerkByPlan(index)">
            <u>Your Benefits</u>
          </b-card-text>

          <b-card-text>
            Copy Your Code: 
            <b>{{showCoupom(index)}}</b> 
          </b-card-text>

          <!-- Flipping cards functionality is
          <transition name="flip">
          <p v-bind:key="product.flipped" class="card">
              {{ product.flipped ? showPerkByPlan(index) : showCoupom(index) }}
          </p>
          </transition> -->
          <div v-if="false">
            <b-form-rating
              v-model="rating"
              class="rating-box responsive-rating"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
          <b-button class="see-perk-details-button" :href="product.buttonUrl" pill variant="outline-dark" target="_blank">Get your perk</b-button>
        </b-card>
      </b-card-group>
    </div>

    <!-- TOAST TO NO MORE PRODUCTS -->
    <div style="display: flex; justify-content: center; margin-bottom: 4rem;">
      <b-toast
        id="no-more-product-toast"
        static
        auto-hide-delay="7000"
        variant="secondary"
        no-close-button
      >
        No more products to show.
      </b-toast>
    </div>
    <!-- BUTTON -->
    <div class="button-see-more-box" v-if="false">
      <b-button
        pill
        variant="outline-dark"
        class="button-see-more"
        @click="seeMoreProducts"
        >See More</b-button
      >
    </div>
  </div>
</template>

<script>
import perkJoyImage from "@/assets/images/Perks-Dropsmart-Joy-Bowles.png";
import dropImage from "@/assets/logo.png"; 
import comingSoon1Image from "@/assets/images/perks-coming-soon-1.png";
import comingSoon2Image from "@/assets/images/perks-coming-soon-2.png";


export default {
  name: "ProductCard",
  components: {},
  props: ["customerInfo"],
  data() {
    return {
      rating: 3.555,
      reviewsNumber: 288,
      cardsData: [
        {
          id: 1,
          buttonUrl: "https://expo.dropsmarteo.com/joy-bowles/how-eos-work",
          productTitle: "How Essential Oils Work",
          description: 'Dr Joy E. Bowles',
          price: 320.0,
          priceFreeUsers: 288.0,
          freeDiscount: 10, //percentage
          coupomFree: '10TPHJOOQ',
          priceMonthlyUsers: 256.0,
          monthlyDiscount: 20, //percentage
          coupomMonthly: '20TPHUUG',
          priceYearlyUsers: 224.0,
          yearlyDiscount: 30, //percentage
          additionalPerk: "plus one-on-one consultation valued at 180 EUR",
          coupomYearly: '30TPYAAY',
          cardImage: perkJoyImage,
          showOnDeck: true,
          flipped: false,
        },
        {
          id: 2,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: comingSoon1Image,
          showOnDeck: true,
          flipped: false,
        },
        {
          id: 3,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: comingSoon2Image,
          showOnDeck: true,
          flipped: false,
        },
        {
          id: 4,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: comingSoon1Image,
          showOnDeck: false,
          flipped: false,
        },
        {
          id: 5,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: comingSoon2Image,
          showOnDeck: false,
          flipped: false,
        },
        {
          id: 6,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: dropImage,
          showOnDeck: false,          
          flipped: false,
        },
        {
          id: 7,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: dropImage,
          showOnDeck: false,          
          flipped: false,
        },
        {
          id: 8,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: dropImage,
          showOnDeck: false,         
          flipped: false,
        },
        {
          id: 9,
          productTitle: "Coming soon...",
          description: '-',
          price: 0,
          priceFreeUsers: 0,
          freeDiscount: 0, //percentage
          coupomFree: '',
          priceMonthlyUsers: 0,
          monthlyDiscount: 0, //percentage
          coupomMonthly: '',
          priceYearlyUsers: 0,
          yearlyDiscount: 0, //percentage
          coupomYearly: '',
          cardImage: dropImage,
          showOnDeck: false,
          flipped: false,
        },
      ],
    };
  },
  computed: {
    activeCards: function() {
      return this.cardsData.filter(function(u) {
        return u.showOnDeck;
      });
    },
  },
  methods: {
    toggleCard: function(card) {
      card.flipped = !card.flipped;
    },
    showPrice(index) {
      return this.cardsData[index].price.toFixed(2) + " EUR";
    },
    showPriceByPlan(index) {
      let price = 0;
      if (this.customerInfo === null) {
       return "";
      } 
      else {
        if (!this.customerInfo.user.paid) {
        price = this.cardsData[index].priceFreeUsers;
      } 
      else {
        if(this.customerInfo.user.plan === "Monthly") {
          price = this.cardsData[index].priceMonthlyUsers;
        } else {
          price = this.cardsData[index].priceYearlyUsers;
        }
      }
      }
      return price + " EUR";
    },
    showPerkByPlan(index) {
      let partnerName = this.cardsData[index].description;
      let percentual = 0;
      let additionalPerk = "";
      if (this.customerInfo === null) {
       return "";
      } 
      else {
        if (!this.customerInfo.user.paid) {
        percentual = this.cardsData[index].freeDiscount;
      } 
      else {
        if(this.customerInfo.user.plan === "Monthly") {
          percentual = this.cardsData[index].monthlyDiscount;
        } else {
          percentual = this.cardsData[index].yearlyDiscount;
          additionalPerk = this.cardsData[index].additionalPerk;
        }
      }
      }
      return `${partnerName} offers you ${percentual}% OFF ${additionalPerk}.`;
    },
    showUserPlan() {
      let plan = "";
      if (this.customerInfo === null) {
       return "";
      } 
      else {
        if (!this.customerInfo.user.paid) {
        plan = "Free";
        } 
        else {
        plan = this.customerInfo.user.plan;
        }
      }
      return `As a ${plan} Client You Get:`;
    },
    showCoupom(index) {
      let coupom = "";
      if (this.customerInfo === null) {
       return "";
      } 
      else {
        if (!this.customerInfo.user.paid) {
        coupom = this.cardsData[index].coupomFree;
      } 
      else {
        if(this.customerInfo.user.plan === "Monthly") {
        coupom = this.cardsData[index].coupomMonthly;
        } else {
        coupom = this.cardsData[index].coupomYearly;
        }
      }
      }
      return coupom;
    },
    seeMoreProducts() {
      //check there is more product to be shown on deck
      const count = this.cardsData.reduce(
        (counter, { showOnDeck }) =>
          showOnDeck === false ? (counter += 1) : counter,
        0
      );
      if (count > 0) {
        //generate a subarray with all hidden cardsData
        //set their value to true
        // let i = 0;
        // const newArr = this.cardsData.map((object) => {
        //   if (object.showOnDeck === false && i < 4) {
        //     //change value of showOnDeck property
        //     return { ...object, showOnDeck: true };
        //   }
        //   return object;
        // });
        // console.log(newArr);
        // this.activeCards;
        // i++;
      } else {
        this.$bvToast.show("no-more-product-toast");
      }
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.popular-title {
  font-weight: 700;
  margin: 3rem 0;
}


.deck-cards {
  display: flex;
  justify-content: flex-start;
  margin: auto;
  justify-content: space-evenly;
}

div.card {
  border: none;
  //display: inline-block;
}

//div#productCard {
//  transition: all 0.3s ease;
//  cursor: pointer;

//  &.hover {
//      transform: scale(1.1);
//    }
//}

.card-img-top {
  //background-color: $light-gray;
    width: 100%;
    //max-height: 19.5vw; //312px
    //object-fit: cover;

}

h4.card-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.add-border-radius {
  border-radius: 1rem;
  //min-width: 209.5px;
  //max-width: 340px;
  //max-width: 220px;

  margin: 1rem 1.25rem;

  //object-fit: cover;

  img {
    border-radius: 1rem 1rem 0 0;
    background-color: $light-gray;
    //height: 320px;
  }
}

.see-perk-details-button {
  //display: flex;
  //justify-content: center;
    font-weight: 700;
    color: black;
    &:hover {
      background-color: black;
      color: white;

  }
}

.original-price {
  text-decoration: line-through;
}

//FLIP CARD
  //.flip-enter-active {
  //  transition: all 0.4s ease;
  //}
  
  //.flip-leave-active {
  //  display: none;
  //}
  
  //.flip-enter, .flip-leave {
  //  transform: rotateY(180deg);
  //  opacity: 0;
  //}

</style>
